import { CognitoUserPool, CognitoUserAttribute, AuthenticationDetails, CognitoUser } from 'amazon-cognito-identity-js';

// Login Method
const postLogin = (user) => {
    const poolData = {
        UserPoolId : process.env.REACT_APP_USERPOOLID,
        ClientId : process.env.REACT_APP_CLIENTID,
    }
    const UserPool = new CognitoUserPool(poolData)

    const userCog = new CognitoUser ({
        Username: user.email,
        Pool: UserPool
    })

    const authDetails = new AuthenticationDetails({
        Username: user.email,
        Password: user.password
    });

    return new Promise((resolve, reject) => (
        userCog.authenticateUser(authDetails, {
            onSuccess: (result) => {
                resolve([200, result])
            },
            onFailure: (err) => {
                reject([err.status, err.message])
            }
        })
    ))
}

// Register Method
const Attrib = (name, value) =>{
    const attributeObj = { Name: name, Value: value }
    const attributeCog = new CognitoUserAttribute(attributeObj);
    return attributeCog
}

const postRegister = (data) => {
    const poolData = {
        UserPoolId : process.env.REACT_APP_USERPOOLID,
        ClientId : process.env.REACT_APP_CLIENTID,
    }
    const UserPool = new CognitoUserPool(poolData)

    let attributeList = []
    const attribNameList = ["name", "family_name"]
    for (let i = 0; i < attribNameList.length ; i++) {
        let tempAttribute = Attrib( attribNameList[i], data[attribNameList[i]] )
        attributeList.push(tempAttribute)
    }

    return new Promise((resolve, reject) => {
        UserPool.signUp(data.email, data.password, attributeList, null, (err, data) => {
            if (err) {
                reject([err.status, err.message])
                return
            }
            let cognitoUser = data.user
            resolve([200, cognitoUser])
        })
    })
}

// postForgetPwd 
const postForgetPwd = (data) => {
    const poolData = {
        UserPoolId : process.env.REACT_APP_USERPOOLID,
        ClientId : process.env.REACT_APP_CLIENTID,
    }
    const UserPool = new CognitoUserPool(poolData)

    const cognitoUser = new CognitoUser({
        Username: data.email,
        Pool: UserPool
    });
    return new Promise((resolve, reject) => {
        cognitoUser.forgotPassword({
            onSuccess: function(result) {
                const msg = "Reset link are sended to your mailbox, check there first"
                return msg
            },
            onFailure: function(err) {
                alert(err.message);
            }
            // inputVerificationCode() { // this is optional, and likely won't be implemented as in AWS's example (i.e, prompt to get info)
            //     var verificationCode = prompt('Please input verification code ', '');
            //     var newPassword = prompt('Enter new password ', '');
            //     cognitoUser.confirmPassword(verificationCode, newPassword, this);
            // }
        });
    })
    
}

const postResetPwd = (data) => {
    const poolData = {
        UserPoolId : process.env.REACT_APP_USERPOOLID,
        ClientId : process.env.REACT_APP_CLIENTID,
    }
    const UserPool = new CognitoUserPool(poolData)

    const cognitoUser = new CognitoUser({
        Username: data.email,
        Pool: UserPool
    });
    
    cognitoUser.confirmPassword(data.code, data.password, {
        onFailure: function(err) {
            alert(err.message)
        },
        onSuccess: function(result) {
            const msg = "Password reset successfully!"
            return msg
        },
    });
}

export { postLogin, postRegister, postForgetPwd, postResetPwd }